'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _draftJsLinkifyPlugin = require('draft-js-linkify-plugin');

var _draftJsLinkifyPlugin2 = _interopRequireDefault(_draftJsLinkifyPlugin);

var _DraftLinkAnchor = require('./DraftLinkAnchor');

var _DraftLinkAnchor2 = _interopRequireDefault(_DraftLinkAnchor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
exports.default = function () {
    return (0, _draftJsLinkifyPlugin2.default)({
        target: '_blank',
        component: _DraftLinkAnchor2.default
    });
};

// Components


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/linkify/index.js
// module id = 686
// module chunks = 0